import PdfAttach from "../../PageComponents/PdfAttach/PdfAttach";
import FormLabel from "../FormLabel/FormLabel";

const AttachHeadOfDepartmentStatement = ({
  onFilesSelect,
  totalFiles,
  maxFiles,
}) => {
  const storageKey = "headOfDepartmentStatementFiles";
  return (
    <div style={{ marginBottom: "20px" }}>
      <FormLabel
        label={
          "Izjava predstojnika zavoda, Privola za slanje osobnih podataka trećim stranama**"
        }
      />
      <PdfAttach
        onFilesSelect={onFilesSelect}
        storageKey={storageKey}
        totalFiles={totalFiles}
        maxFiles={maxFiles}
      />
    </div>
  );
};

export default AttachHeadOfDepartmentStatement;
